import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import Modal from 'srcReact/components/common2/Modal'
import InviteMembersSuccessModal from 'srcReact/components/popinsContent/InviteMembersSuccessModal'
import InviteByEmail from 'srcReact/components/common2/InviteWPMembers/components/InviteByEmail'
import MemberExceedInOrgPopin from 'srcReact/components/popinsContent/MemberExceedInOrgPopin'
import MemberAlreadyExistInWPPopin from 'srcReact/components/popinsContent/MemberAlreadyExistInWPPopin'
import { isOrganizationManager } from 'srcReact/helpers/organizationHelper'
import { redirectToPage } from 'srcReact/helpers/history'

const InviteMembers = ({ selectedWorkplace, className, isWPCreationStep = false }) => {
  const {
    common: { isMobile },
    organization: { current_organization }
  } = useSelector((state) => state)

  const [alreadyAcceptedEmails, setAlreadyAcceptedEmails] = useState([])
  const [showMemberAlreadyExistModal, setShowMemberAlreadyExistModal] = useState(false)
  const [showMemberExceedModal, setShowMemberExceedModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)

  const handleAfterInviteSuccess = (data) => {
    if (data?.already_accepted_emails?.length > 0 && data?.already_accepted_emails?.length === data?.quantity_email) {
      setAlreadyAcceptedEmails(data?.already_accepted_emails)
      setShowMemberAlreadyExistModal(true)
    } else {
      setShowSuccessModal(true)
    }
    localStorage.removeItem(`group_mixr_invite_${selectedWorkplace?.id}`)
  }
  const handleAfterInviteFailure = (error) => {
    if (error && error === 'You are exceeding the limitation of users in this Organization') {
      setShowMemberExceedModal(true)
    }
  }
  const closeMemberExceedModal = () => {
    setShowMemberExceedModal(false)
  }
  const goToMembersPage = () => {
    closeMemberExceedModal()
    redirectToPage(`/0/workplace/settings/${selectedWorkplace?.id}?section=link_3`, true)
  }
  const closeMemberAlreadyExistModal = () => {
    setShowMemberAlreadyExistModal(false)
  }

  return (
    <div className={`${styles.inviteMembersWrapper} ${className}`}>
      <InviteByEmail
        type='workplace'
        workplaceId={selectedWorkplace?.id}
        isMobile={isMobile}
        callbackSuccessFun={handleAfterInviteSuccess}
        callbackFailureFun={handleAfterInviteFailure}
      />
      {showSuccessModal && (
        <Modal isOpen={showSuccessModal} handleClose={() => setShowSuccessModal(false)}>
          <InviteMembersSuccessModal
            closeModal={() => setShowSuccessModal(false)}
            {...(isWPCreationStep ? { redirectLink: '/0/general_group_created' } : {})}
          />
        </Modal>
      )}
      {showMemberAlreadyExistModal && (
        <MemberAlreadyExistInWPPopin
          emails={alreadyAcceptedEmails}
          isOpen={showMemberAlreadyExistModal}
          closeModal={closeMemberAlreadyExistModal}
        />
      )}
      {showMemberExceedModal && (
        <MemberExceedInOrgPopin
          isOpen={showMemberExceedModal}
          closeModal={closeMemberExceedModal}
          isOrgManager={isOrganizationManager(current_organization)}
          goToMembersPage={goToMembersPage}
        />
      )}
    </div>
  )
}

export default InviteMembers
